import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.map.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
const getIndex = (i, arr)=>i + 1 >= arr.length ? 0 : i + 1;
const StyledTypographyAnimated = styled.span.withConfig({
    componentId: "sc-271789bc-0"
})([
    `display:inline-block;position:relative;white-space:nowrap;transition:width 0.25s;vertical-align:baseline;.r-txt{top:0;left:0;position:absolute;opacity:0;}&.type--blur-out .r-txt{transform:translateY(-75%);filter:blur(20px);transition:filter 0.75s,opacity 0.75s 0.25s,transform 0.75s;}&.type--swipe-up{overflow:hidden;position:relative;vertical-align:bottom;line-height:inherit;}&.type--swipe-up .r-txt{transform:translateY(-100%);transition:opacity 0s 1s,transform 0.75s;}&.type--blur-out .r-next{transform:translateY(25%);filter:none;}&.type--swipe-up .r-next{transform:translateY(100%);opacity:1;}&.rotating-text .r-active{transform:translateY(0);opacity:1;}&.type--blur-out .r-active{opacity:1;filter:none;transition-delay:0.075s;}.hidden{color:transparent;opacity:0;}`
]);
const TypographyAnimated = ({ texts, type = 'swipe-up', duration = 3, pause = false })=>{
    const [activeIndex, setActiveIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const durationInMS = duration * 1000;
    const timer = useRef(null);
    const stopInterval = ()=>{
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    };
    useEffect(()=>{
        if (pause) {
            setActiveIndex(texts.length - 1);
            setNextIndex(0);
            stopInterval();
        } else {
            // if we want to quickly show next text on blur
            // setActiveIndex(0);
            // setNextIndex(1);
            timer.current = setInterval(()=>{
                if (document.hidden) return;
                setActiveIndex((i)=>getIndex(i, texts));
                setNextIndex((j)=>getIndex(j, texts));
            }, durationInMS);
        }
        return stopInterval;
    }, [
        durationInMS,
        pause,
        texts
    ]);
    const longestText = texts.reduce((longest, text)=>{
        return text.length > longest.length ? text : longest;
    }, '');
    return /*#__PURE__*/ _jsxs(StyledTypographyAnimated, {
        className: `rotating-text type--${type}`,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "hidden",
                children: longestText
            }),
            texts.map((t, i)=>/*#__PURE__*/ _jsx("span", {
                    className: `r-txt
          ${i === activeIndex ? 'r-active' : ''}
          ${i === nextIndex ? 'r-next' : ''}`,
                    children: t
                }, i))
        ]
    });
};
export default TypographyAnimated;
